import React from "react";
import {
  Box,
  Autocomplete,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";
import { Contact } from "../../interfaces/DTO/crm/contact";
import { formatName } from "../../utils/namesFormater";

interface ContactAutocompleteProps {
  placeholder: string;
  options: Contact[];
  value: Contact | null;
  onChange: (newContact: Contact | null) => void;
}

const ContactAutocomplete: React.FC<ContactAutocompleteProps> = ({
  placeholder,
  options,
  value,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#e0e0e0",
        borderRadius: "8px",
        paddingX: "8px",
        width: "100%",
        maxWidth: 400,
      }}
    >
      <Autocomplete
        options={options}
        getOptionLabel={(option) => formatName(option)}
        value={value}
        onChange={(_event, newValue) => onChange(newValue)}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        sx={{ flexGrow: 1 }}
        slotProps={{
          paper: { sx: { direction: "rtl", textAlign: "right" } },
          listbox: { sx: { direction: "rtl" } },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            placeholder={placeholder}
            fullWidth
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: "gray" }} />
                </InputAdornment>
              ),
              startAdornment: value ? (
                <InputAdornment position="start">
                  <IconButton size="small" onClick={() => onChange(null)}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              "& .MuiInputBase-input": {
                padding: "10px",
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default ContactAutocomplete;
